import { VERIFY_OTP_SUCCESS, VERIFY_OTP_FAILED, CLEAR_VERIFY_OTP } from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
      };
    case VERIFY_OTP_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_VERIFY_OTP:
      return initialState;
    default:
      return state;
  }
};
